// @ts-strict-ignore
import {Pipe, PipeTransform} from "@angular/core";
import {SimMediasetService} from "@services";
import {from, Observable, of} from "rxjs";
import {Mediaset} from "@models";

@Pipe({
	name: "getScenarioMediaSetById",
	standalone: false,
})
export class GetScenarioMediaSetByIdPipe implements PipeTransform {
	constructor(private _simMediaSetService: SimMediasetService) {}

	transform(mediaSetId: string): Observable<Mediaset> {
		if (!mediaSetId) {
			return of(null);
		}
		return from(this._simMediaSetService.getMediasetById(mediaSetId));
	}
}
